export const pageview = (url: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'pageview',
        page_path: url,
    });
};
